import { SET_LOCALES, SetLocalesPayload } from "./types";
import { action } from "typesafe-actions";

export const setLocalesAction = (payload: SetLocalesPayload) =>
  action(SET_LOCALES, payload);
